var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconExit = function SvgIconExit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8479 10.4379C11.9426 10.5318 11.9958 10.6596 11.9958 10.7929C11.9958 10.9262 11.9426 11.054 11.8479 11.1479L11.1479 11.8479C11.054 11.9426 10.9262 11.9958 10.7929 11.9958C10.6596 11.9958 10.5318 11.9426 10.4379 11.8479L5.9979 7.4079L1.5579 11.8479C1.46402 11.9426 1.33622 11.9958 1.2029 11.9958C1.06958 11.9958 0.941782 11.9426 0.847899 11.8479L0.147899 11.1479C0.0532428 11.054 0 10.9262 0 10.7929C0 10.6596 0.0532428 10.5318 0.147899 10.4379L4.5879 5.9979L0.147899 1.5579C0.0532428 1.46402 0 1.33622 0 1.2029C0 1.06958 0.0532428 0.941782 0.147899 0.847899L0.847899 0.147899C0.941782 0.0532428 1.06958 0 1.2029 0C1.33622 0 1.46402 0.0532428 1.5579 0.147899L5.9979 4.5879L10.4379 0.147899C10.5318 0.0532428 10.6596 0 10.7929 0C10.9262 0 11.054 0.0532428 11.1479 0.147899L11.8479 0.847899C11.9426 0.941782 11.9958 1.06958 11.9958 1.2029C11.9958 1.33622 11.9426 1.46402 11.8479 1.5579L7.4079 5.9979L11.8479 10.4379Z",
    fill: "#A9ADBB"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconExit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconExit.54f3dcb1.svg";
export { ForwardRef as ReactComponent };